export default "__VITE_ASSET__bIZsGFk4__"